// 授权合作类型
export const AUTH_COOPERATION_TYPE = {
  1: "良信经销商",
  2: "良信原合作盘厂",
  3: "地区部开发资源盘厂",
  4: "智拓主导开发盘厂",
};

// 人员数量类型
export const STAFF_COUNT = {
  1: "10人以下",
  2: "10~49人",
  3: "50~99人",
  4: "100~499人",
  5: "500~1000人",
  6: "1000人以上",
};

export const STAFF_COUNT_OPTIONS = [
  { label: "10人以下", value: 1 },
  { label: "10~49人", value: 2 },
  { label: "50~99人", value: 3 },
  { label: "100~499人", value: 4 },
  { label: "500~1000人", value: 5 },
  { label: "1000人以上", value: 6 },
];

export default {
  AUTH_COOPERATION_TYPE,
  STAFF_COUNT,
  STAFF_COUNT_OPTIONS,
};
